import Chip from "@mui/material/Chip";

// Badge padrão de participação — compartilhado entre a lista e a ficha
export const ParticipatedChip = ({
  participated,
}: {
  participated?: boolean | null;
}) => (
  <Chip
    size="small"
    variant="outlined"
    color={participated ? "success" : "default"}
    label={participated ? "Participou" : "Não participou"}
  />
);
